/**
 * Component Registry for The Residences at Bluhawk Apartment Homes
 *
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import SisterProperties from './components/SisterProperties';
import { TabbedCallouts } from './components/TabbedCallouts';
import { GallerySeparator } from './components/GallerySeparator';
import { C26HubFeatures } from './components/C26HubFeatures';
import { C26HubAccess } from './components/C26HubAccess';
import { C26HubFlyer } from './components/C26HubFlyer';
import { HawkFlockPartners } from './components/HawkFlockPartners';
import Header from './components/Header';
import { Footer } from './components/Footer';
import HeroSolidBG from './components/HeroSolidBG';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  HeroSolidBG,
  SisterProperties,
  TabbedCallouts,
  GallerySeparator,
  C26HubFeatures,
  C26HubAccess,
  C26HubFlyer,
  HawkFlockPartners,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
